<template>
  <section class="page_privacy_section" v-if="!isLoading">
    <div class="top-header"></div>
    <b-container class="h-100">
      <b-row class="h-100 ">
        <b-col sm="12">
          <h1>{{$t('eula.title')}}</h1>
          <p>{{$t('eula.updated_at')}}</p>

          <p>{{$t('eula.grexy_hereby_grants_you_access')}}</p>

          <h1>{{$t('eula.title1')}}</h1>
          <p>{{$t('eula.to_help_explain_things')}}</p>
          <ul>
            <li v-for="item in $t('eula.definitions_and_key_terms')" :key="item">{{ item }}</li>
          </ul>

          <h1>{{$t('eula.introduction')}}</h1>
          <p v-for="item in $t('eula.introduction_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.rights_and_duties_of_the_administration')}}</h1>
          <p v-for="item in $t('eula.rights_and_duties_of_the_administration_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.rights_and_obligations_of_the_user')}}</h1>
          <ul style="list-style-type: none;padding: 0;">
            <li v-for="item in $t('eula.rights_and_obligations_of_the_user_content')" :key="item">{{ item }}</li>
          </ul>

          <h1>{{$t('eula.intellectual_property_rights')}}</h1>
          <p v-for="item in $t('eula.intellectual_property_rights_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.responsibilities_of_the_parties')}}</h1>
          <p v-for="item in $t('eula.responsibilities_of_the_parties_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.other_conditions')}}</h1>
          <p v-for="item in $t('eula.other_conditions_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.terms_of_use_of_the_service')}}</h1>
          <p>{{$t('eula.terms_of_use_of_the_service_content')}}</p>
          <p>{{$t('eula.general_rules_for_using_the_service')}}</p>
          <p v-for="item in $t('eula.general_rules_for_using_the_service_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.restrictions_when_using_the_service')}}</h1>
          <p v-for="item in $t('eula.restrictions_when_using_the_service_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.responsibility')}}</h1>
          <p v-for="item in $t('eula.responsibility_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.consent_to_the_processing_of_personal_data')}}</h1>
          <p v-for="item in $t('eula.consent_to_the_processing_of_personal_data_content')" :key="item">{{ item }}</p>

          <h1>{{$t('eula.contact_us')}}</h1>
          <p>{{$t('eula.contact_us_content')}}</p>

          <ul>
            <li>{{$t('eula.via_email')}} <a href="mailto:info@grexy.co" class="address-link">info@grexy.co</a></li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Eula',
  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.actionPreloader(true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.actionPreloader(false)
      }, 2000)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/sass/app";

.top-header{
  height: 95px;
  background: radial-gradient(66.25% 121.93% at 70.64% -15.07%, #8184F9 12.26%, #5C5EE8 91.15%);
  margin-bottom: 80px;
}
.page_privacy_section{
  h1{
    color: #30394B;
    font-family: $main-font;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 38.4px;
    margin: 0 0 24px 0;
  }
  p{
    color: #30394B;
    font-family: $main-font;
    font-style: normal;
    font-weight: 300;
    line-height: 28px;
    font-size: 18px;
  }
  ul{
    li{
      color: #30394B;
      font-family: $main-font;
      font-style: normal;
      font-weight: 300;
      line-height: 28px;
      font-size: 18px;
      margin-bottom: 10px;
    }
  }
}
</style>
